export interface GrowthScores {
  seeIt: number;
  bridgeIt: number;
  beIt: number;
}

export interface GrowthOption {
  text: string;
  scores: GrowthScores;
}

export interface GrowthQuestion {
  id: number;
  question: string;
  options: GrowthOption[];
}

export const growthQuestions: GrowthQuestion[] = [
  {
    id: 1,
    question: "When you think about your ideal future, what comes to mind?",
    options: [
      {
        text: "I have a crystal-clear vision that excites me",
        scores: { seeIt: 0, bridgeIt: 0, beIt: 0 }
      },
      {
        text: "I have general ideas but the details are fuzzy",
        scores: { seeIt: 3, bridgeIt: 1, beIt: 1 }
      },
      {
        text: "I know what I don't want more than what I do want",
        scores: { seeIt: 5, bridgeIt: 2, beIt: 2 }
      },
      {
        text: "I feel completely uncertain about my direction",
        scores: { seeIt: 7, bridgeIt: 2, beIt: 2 }
      }
    ]
  },
  {
    id: 2,
    question: "How aligned do your daily actions feel with your bigger goals?",
    options: [
      {
        text: "Completely aligned—my habits support my vision",
        scores: { seeIt: 0, bridgeIt: 0, beIt: 0 }
      },
      {
        text: "Somewhat aligned but inconsistent",
        scores: { seeIt: 1, bridgeIt: 3, beIt: 1 }
      },
      {
        text: "Often misaligned—I know what to do but struggle to do it",
        scores: { seeIt: 1, bridgeIt: 5, beIt: 2 }
      },
      {
        text: "Completely disconnected from my aspirations",
        scores: { seeIt: 2, bridgeIt: 7, beIt: 2 }
      }
    ]
  },
  {
    id: 3,
    question: "When you face obstacles in pursuing your goals, what typically happens?",
    options: [
      {
        text: "I adapt and find new ways forward",
        scores: { seeIt: 0, bridgeIt: 0, beIt: 0 }
      },
      {
        text: "I push through but it feels like a constant struggle",
        scores: { seeIt: 1, bridgeIt: 3, beIt: 2 }
      },
      {
        text: "I get discouraged and often give up",
        scores: { seeIt: 2, bridgeIt: 4, beIt: 3 }
      },
      {
        text: "I avoid challenges to prevent disappointment",
        scores: { seeIt: 2, bridgeIt: 5, beIt: 3 }
      }
    ]
  },
  {
    id: 4,
    question: "How supported do you feel in your growth journey?",
    options: [
      {
        text: "I have a strong circle that champions my growth",
        scores: { seeIt: 0, bridgeIt: 0, beIt: 0 }
      },
      {
        text: "I have some support but crave deeper connections",
        scores: { seeIt: 1, bridgeIt: 2, beIt: 2 }
      },
      {
        text: "I feel mostly alone in my journey",
        scores: { seeIt: 2, bridgeIt: 3, beIt: 4 }
      },
      {
        text: "My current environment actually holds me back",
        scores: { seeIt: 2, bridgeIt: 4, beIt: 5 }
      }
    ]
  },
  {
    id: 5,
    question: "When you've made positive changes before, what typically happens long-term?",
    options: [
      {
        text: "They stick and become part of who I am",
        scores: { seeIt: 0, bridgeIt: 0, beIt: 0 }
      },
      {
        text: "They work for a while but I eventually revert",
        scores: { seeIt: 1, bridgeIt: 2, beIt: 5 }
      },
      {
        text: "I make progress but can't seem to break through to the next level",
        scores: { seeIt: 2, bridgeIt: 3, beIt: 4 }
      },
      {
        text: "I struggle to even get changes started",
        scores: { seeIt: 3, bridgeIt: 5, beIt: 2 }
      }
    ]
  }
];
